import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["activeOptions", "allowMultiple", "closeOnSelect", "field", "isClearable", "isDisabled", "onClearActive", "onBlur", "onFocusedOptionChange", "onOptionSelect", "onKeyDown", "onKeyUp", "onMouseOut", "optionDisabled", "optionIdProp", "options", "optionSearchProp", "renderLabel", "renderOption", "renderOptionList", "noResults", "onUpdate", "onChange"];
import * as React from 'react';
import { IconCaretDown } from '../../../../icons';
import { Button } from '../../../button';
import { Select } from './select';
export var SelectButton = function SelectButton(props) {
  var activeOptions = props.activeOptions,
    allowMultiple = props.allowMultiple,
    closeOnSelect = props.closeOnSelect,
    field = props.field,
    isClearable = props.isClearable,
    isDisabled = props.isDisabled,
    onClearActive = props.onClearActive,
    onBlur = props.onBlur,
    onFocusedOptionChange = props.onFocusedOptionChange,
    onOptionSelect = props.onOptionSelect,
    onKeyDown = props.onKeyDown,
    onKeyUp = props.onKeyUp,
    onMouseOut = props.onMouseOut,
    optionDisabled = props.optionDisabled,
    optionIdProp = props.optionIdProp,
    options = props.options,
    optionSearchProp = props.optionSearchProp,
    renderLabel = props.renderLabel,
    renderOption = props.renderOption,
    renderOptionList = props.renderOptionList,
    noResults = props.noResults,
    onUpdate = props.onUpdate,
    onChange = props.onChange,
    rest = _objectWithoutProperties(props, _excluded);
  return React.createElement(Select, {
    activeOptions: activeOptions,
    allowMultiple: allowMultiple,
    closeOnSelect: closeOnSelect,
    field: field,
    isClearable: isClearable,
    isDisabled: isDisabled,
    onChange: onChange,
    onOptionSelect: onOptionSelect,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onMouseOut: onMouseOut,
    onUpdate: onUpdate,
    optionDisabled: optionDisabled,
    optionIdProp: optionIdProp,
    options: options,
    renderLabel: renderLabel,
    renderOption: renderOption,
    renderOptionList: renderOptionList,
    noResults: noResults
  }, function (selectProps) {
    return React.createElement(Button, _extends({}, rest, selectProps.eventHandlers, {
      isDisabled: isDisabled,
      label: selectProps.defaultLabel,
      after: React.createElement(IconCaretDown, null)
    }));
  });
};